module.exports = __webpack_public_path__ + "img/clipboard-check.ced1d4f4.svg";